<template>
  <div>
    <header-form
      ref="form"
      :indicators="indicators"
      :categories="categories"
      :state="userState"
      :city="userCity"
      :reports="savedReports"
      :report="userReport"
      :questionnaires="questionnaires"
      :questionnaires-intelligent="questionnairesIntelligent"
      :rates="rates"
      :data="formData"
      :results="results"
      :config="config"
      :roleId="roleId"
    />

    <dinamic-table ref="table" :results="resultsTable" />

    <multiple-charts ref="charts" category="home" :charts="resultsChart" />
  </div>
</template>

<script>
import DinamicTable from '@/Indicators/Components/DinamicTable'
import HeaderForm from '@/Indicators/Components/HeaderForm'
import MultipleCharts from '@/Indicators/Components/MultipleCharts'

export default {
  components: {
    DinamicTable,
    HeaderForm,
    MultipleCharts,
  },
  props: {
    roleId: Number,
    userState: Number,
    userCity: Array,
    indicators: Object,
    categories: Object,
    fieldsets: Object,
    savedReports: Array,
    userReport: Number,
    questionnaires: Array,
    questionnairesIntelligent: Array,
    rates: Array,
    results: Object,
    formData: Object,
    config: Object,
  },
  data() {
    return {
      $this: this,
      get resultsTable() {
        return this.$this.results?.table
      },
      get resultsChart() {
        if (!this.$this.results?.chart || !this.$this.results.chart.home) {
          return []
        }

        const charts = []

        this.$this.results.chart.home._order.forEach((chart) =>
          charts.push(this.$this.results.chart.home[chart]),
        )

        return charts
      },
    }
  },
}
</script>
